angular.module('logbook')
.service('template-value-calculator', ['$q', 'tag-ancestor-resolver', 'mathJsService',
	function($q, tagAncestorResolver, mathJsService) {
      var service = {
         calculateDependencyGraph: function(segments) {
            var graph = {};
            var valueByIdRegExp = new RegExp('[a-z_]+ = \\$id[0-9]+( # optional)?','ig');
            segments.filter(function(ts) {
               return ts.calculate && ts.formula && !ts.obsolete; 
            }).forEach(function(ts) {
               var dependencies = {};
               var matches = ts.formula.match(valueByIdRegExp);
               if( !matches ) matches = [];
               var node = {};
               node.id = ts.id;
               node.ts = ts;
               node.optionalVars = {};
               node.variableMap = {};
               node.dependsOn = matches.map(function(m) {
                  var varName = m.substring(0,m.indexOf('=') - 1)
                  var id = parseInt(m.substring(m.indexOf('=')+2).substring(3));
                  node.variableMap[varName.toLowerCase()] = id;
                  node.optionalVars[id] = m.indexOf(' # optional') == m.length - 11;
                  return id;
               });
               var extValueRegExp = new RegExp('[a-z_]+ = \\$extValues\\[\'(.*)\'\\]+( # optional)?','ig');
               matches = ts.formula.match(extValueRegExp) || [];
               node.dependsOnExtValues = matches.filter(m => m.indexOf(' # optional') < 0).map(m => {
                  return m.substring(m.indexOf('=')+14, m.lastIndexOf("'"));
               });
               node.isDependedOn = [];
               graph[ts.id] = node;
            });
            Object.keys(graph).forEach(function(id) {
               graph[id].dependsOn
               .filter(function(n) { return graph[n];})
               .forEach(function(dependsOn) {
                  graph[dependsOn].isDependedOn.push(id);
               });
            });
            return service.dfs(graph);
         },
         findTag: function(tagHrefArray, tagObjects) {
             if( !tagHrefArray || tagHrefArray.length == 0 )
                 return;
             for( var i=0; i < tagObjects.length; i++ )
                 if( tagObjects[i]._links.self.href == tagHrefArray[0] )
                     return tagObjects[i];
         },
         checkNodeDependencies: function(node, mathScope, segmentMap, errors, completedSegments)
         {
             var missingValue = false;
             node.dependsOn.forEach(function(depId) {
                 if( mathScope['$id'+depId] == undefined )
                 {
                    if( segmentMap[depId] != undefined )
                    {
                       if( node.optionalVars[depId] )
                          mathScope['$id'+depId] = null;
                       else
                          missingValue = true;
                    }
                    else
                       errors.push('Reference to unknown template segment ' + depId + '.');
                 }
              });
             node.dependsOnExtValues.forEach(key => {
                if( !mathScope['$extValues'] || mathScope['$extValues'][key] == undefined )
                    missingValue = true;
             });
             node.isDependedOn.forEach(function(depId)
             {
                 if (completedSegments[depId])
                     errors.push('Circular dependency caused by reference in '
                         + segmentMap[depId].longName
                         + '.');
             });
             
              if (errors.length) {
                throw new Error(errors.join(' '));
              }
              else if (missingValue) {
                throw new Error('Missing value for one or more dependencies.');
              }
         },
         filterTagAncestorCalls: function(node, logId, chosenTags, chosenTagObjects)
         {
             var tagAncestorExpression = 'findTagAncestor\\s*\\(\\s*("?.+"?),\\s+("?.+"?)\\)';
             var tagAncestorRegExp = new RegExp(tagAncestorExpression,'ig');
             var tagAncestorFetches = [];
             var formula = ''+node.ts.formula; // force copy
             var deferred = $q.defer();
             var matches = node.ts.formula.match(tagAncestorRegExp);
             matches && matches.map(function(m) {
                 tagAncestorRegExp = new RegExp(tagAncestorExpression,'ig');
                 var groups = tagAncestorRegExp.exec(m);
                 var isLiteral = [null,false,false];
                 [1,2].forEach(function(idx) {
                     if(groups[idx].charAt(0) == '"' && groups[idx].charAt(groups[idx].length-1) == '"')
                      {
                         groups[idx] = groups[idx].substring(1,groups[idx].length-1);
                         isLiteral[idx] = true;
                      }
                 });
                 var promise = tagAncestorResolver.resolveTagAncestor(
                         isLiteral[1]
                            ? groups[1]
                            : service.findTag(chosenTags[node.variableMap[groups[1].toLowerCase()]], chosenTagObjects),
                         isLiteral[2]
                            ? groups[2]
                            : service.findTag(chosenTags[node.variableMap[groups[2].toLowerCase()]], chosenTagObjects),
                         logId);
                 tagAncestorFetches.push(promise);
                 promise.then(function(result) {
                     formula = formula.replace(groups[0], result && result.length > 0
                             ? '"' + result.map(function(r) { return r.stringValue}).join(', ') + '"'//'"'+result.stringValue+'"' //'[' + result.map(function(r) {return '"'+r.stringValue+'"'}).join() + ']'
                             : '""');
                 });
              });
             $q.all(tagAncestorFetches).then(function() {
                 deferred.resolve(formula);
             });
             return deferred.promise;
         },
         convertResultIfNecessary: function(result, node, logId, chosenTags, chosenTagObjects)
         {
             var deferred = $q.defer();
             if( node.ts.type.name == 'Numeric Input')
             {
                var origResult = result;
                result = Number(result)
                if( isNaN(result) || Math.abs(result) == Infinity )
                   throw new Error("Invalid result: " + origResult);
                if( Math.abs(result) >= 10**17)
                   throw new Error("Result too large.  Maximum allowed value is 10^17.  Result: " + result);
                if( node.ts.decimalPlaces != null )
                   deferred.resolve(mathJsService.round(result,node.ts.decimalPlaces));
             }
             if( node.ts.type.name == 'Checkbox' && result != null )
             {
                if( result == true )
                   deferred.resolve('checked');
                else if( result == false )
                   deferred.resolve('unchecked');
             }
             if( node.ts.type.name == 'Tag Choice' )
             {
                chosenTags[node.id] = [];
                if( result != null && result.trim().length > 0 )
                {
                    var tags = result.split(', ');
                    var tagsToRetrieve = [];
                    var cachedTags = [];
                    tags.forEach(function(tagName) {
                       var tag = tagAncestorResolver.getByName(logId, tagName);
                       if( tag )
                          cachedTags.push(tag);
                       else
                          tagsToRetrieve.push(tagName);
                    });
                    var tagPromise = tagsToRetrieve.length > 0 && tagAncestorResolver.retrieveTagValues
                       ? tagAncestorResolver.retrieveTagValues(tagsToRetrieve, logId)
                       : undefined;
                    $q.when(tagPromise).then(function(results) {
                       chosenTags[node.id] = [];
                       var tagResults = results ? results.data._embedded.tagValues.concat(cachedTags) : cachedTags;
                       tagResults.forEach(function(chosenTag) {
                          chosenTags[node.id].push(chosenTag._links.self.href);
                          if( chosenTagObjects.indexOf(chosenTag) < 0 )
                              chosenTagObjects.push(chosenTag);
                       });
                       deferred.resolve(result);
                    });

                }
             }
             else
                deferred.resolve(result);
             return deferred.promise;
         },
         handleCalculationError: function(node, error, errorMap, valueMap, chosenTags, processedSegments)
         {
             errorMap[node.id] = error.message;
             delete valueMap[node.id];
             delete chosenTags[node.id];
             processedSegments[node.id].resolve(error);
         },
         calculateValues: function(segmentGraph, segmentMap, valueMap, errorMap, chosenTags, chosenTagObjects, logId, timeZone, extValues) {
            var mathScope = {
               '$tz': timeZone,
               '$extValues': extValues
            };
            var processedSegments = {};
            Object.keys(valueMap).forEach(function(id) {
               if( !segmentMap[id] || !segmentMap[id].calculate )
               {
                  var value = valueMap[id];
                  var ts = segmentMap[id];
                  if( moment.isMoment(value) )
                  {
                     if( ts.includeDate && ts.includeTime )
                        value = value.toISOString();
                     else if( !ts.includeDate )
                        value = value.format("HH:mm:ss");
                     else if( !ts.includeTime )
                        value = value.format("YYYY-MM-DD");
                  }
                  mathScope['$id'+id] = value;
                  processedSegments[id] = $q.defer();
                  processedSegments[id].resolve();
               }
            });
            
            var completedSegments = {};
            segmentGraph.forEach(function(node) {
                processedSegments[node.id] = $q.defer();
                delete errorMap[node.id];
                var errors = [];
                var promisesNeeded = [];
                $q.all(node.dependsOn.map(function(depId)
                {
                    
                    var defer = processedSegments[depId];
                    return $q.when((defer) ? defer.promise : undefined);
                    
                })).then(function() {
                    try {
                       service.filterTagAncestorCalls(node, logId, chosenTags, chosenTagObjects)
                           .then(function(formula)
                           {
                                try
                                {
                                   completedSegments[node.id] = node;
                                   service.checkNodeDependencies(node, mathScope, segmentMap, errors, completedSegments);
									var result = mathJsService.evaluate(formula, angular.extend({}, mathScope));
									// var result = limitedEvaluate(formula, angular.extend({}, mathScope));
									
                                   result = typeof(result) == 'object' && result.valueOf
                                      ? result.valueOf()[result.valueOf().length-1]
                                      : result;
                                   service.convertResultIfNecessary(result, node, logId, chosenTags, chosenTagObjects).then(function(result) {
                                      valueMap[node.id] = result;
                                      mathScope['$id'+node.id] = result;
                                      processedSegments[node.id].resolve(result);
                                   });
                                } catch(e) {
                                    service.handleCalculationError(node, e, errorMap, valueMap, chosenTags, processedSegments);
                                }
                       });
                    } catch(e) {
                        service.handleCalculationError(node, e, errorMap, valueMap, chosenTags, processedSegments);
                    }
                 });
            });
            
            return $q.all(Object.keys(processedSegments).map(function(key)
            {
                return processedSegments[key].promise;
            }));
        },
         explore: function(graph, v, visited, postOrderNumber) {
            var self = this;
            visited[v] = true;
            if( !graph[v] )
               return postOrderNumber;
            graph[v].isDependedOn.forEach(function(u) {
               if( !visited[u] )
                  postOrderNumber = self.explore(graph, u, visited, postOrderNumber);
            });
            postOrderNumber++;
            graph[v].postOrderNumber = postOrderNumber;
            return postOrderNumber;
         },
         dfs: function(graph) {
            var visited = {};
            var postOrderNumber = 0;
            var self = this;
            Object.keys(graph).forEach(function(id) {
               if( !visited[id] )
                  postOrderNumber = self.explore(graph, id, visited, postOrderNumber);
            });
            var result = Object.keys(graph).map(function(k) { return graph[k]; });
            result.sort(function(a,b) {
               return b.postOrderNumber - a.postOrderNumber;
            });
            return result;
         }
      };
      return service;
   }
]);